<div class="wrapper-not-register">
    <img class="not-data-img" [src]="'assets/img/not-data-icon.svg'" alt="not-allow">
    <p class="message">{{ text != "" ? text : (BASE_TRANSLATE_SHARED + '.no_records_available' | translate) }}</p>
</div>